import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BACKEND from "../../utils/backend";

export const getUsers = createAsyncThunk(
  "/user/getUsers",
  (search, thunkApi) => {
    try {
      const { pagination } = thunkApi.getState().user;
      const userTypeParam = pagination.userType ? `&userType=${pagination.userType}` : '';
      return new BACKEND().send({
        type: "get",
        to: `/users/?pageNumber=${pagination.page}&pageSize=${
          pagination.pageSize
        }&search=${search || pagination.search}${userTypeParam}`,
        useAlert: false,
      });
    } catch (error) {
      console.error(error);
    }
  }
);
export const getSuperAdminDashboard = createAsyncThunk(
  "/dashboard/getSuperAdminDashboard",
  (search, thunkApi) => {
    try {
      return new BACKEND().send({
        type: "get",
        to: `/admin-dashboard`,
        useAlert: false,
      });
    } catch (error) {
      console.error(error);
    }
  }
);

export const getUserById = createAsyncThunk(
  "/user/getUserById",
  (id, thunkApi) => {
    try {
      return new BACKEND().send({
        type: "get",
        to: `/users/${id}`,
        useAlert: false,
      });
    } catch (error) {
      console.error(error);
    }
  }
);

const initialState = {
  loading: false,
  users: [],
  user: {},
  stats: {},
  pagination: {
    page: 1,
    pageSize: 10,
    total: 0,
    length: 0,
    search: "",
    userType: "",
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setPagination: (state, { payload }) => {
      state.pagination = { ...state.pagination, ...payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUsers.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload?.success) {
          state.users = payload?.data?.users;
          state.pagination.total = payload?.data?.count;
          state.pagination.length =
            state.pagination.pageSize * state.pagination.page;
        }
      })
      .addCase(getUsers.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getUserById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserById.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload?.success) {
          state.user = payload?.data;
        }
      })
      .addCase(getUserById.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getSuperAdminDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSuperAdminDashboard.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload?.success) {
          state.stats = payload?.data;
        }
      })
      .addCase(getSuperAdminDashboard.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setPagination } = userSlice.actions;
export const getUserData = (state) => state.user;
export default userSlice.reducer;
